import React from "react";

import { Box, Flex, Grid } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import { CardAnexo } from "../../CardAnexo";
import { intervalToDuration } from "date-fns";

export const Anexos = ({ dataAnexos, dataNascimento }) => {
  const idade16 = dataNascimento
    ? intervalToDuration({
        start: new Date(dataNascimento),
        end: new Date(),
      }).years >= 16
    : false;

  let dataAnexosChange = dataAnexos;

  if (!idade16) {
    dataAnexosChange = dataAnexosChange?.filter(
      (item) => item?.idTipo !== 5 && item?.idTipo !== 12
    );
  }

  return dataAnexosChange ? (
    <>
      <Box className="break-page">
        <Flex>
          <Group bgColor="#fff" title="Anexos" py="12px" mtDivider="5px">
            <Grid
              templateColumns={"repeat(auto-fit, minmax(230px, 1fr))"}
              mt={6}
              gap={6}
              justifyContent="center"
              alignItems="center"
            >
              {dataAnexosChange?.map((anexo) => {
                const customDateDocument = anexo.dataDocumento
                  ? new Date(anexo?.dataDocumento).toLocaleDateString("pt-BR")
                  : "";

                const customDateInitial = anexo.dataUpload
                  ? new Date(anexo?.dataUpload).toLocaleDateString("pt-BR")
                  : "";

                const data = {
                  tipoAnexo: {
                    id: anexo?.idTipo,
                    descricao: anexo?.tipo,
                    grupo: {
                      id: anexo?.idCategoria,
                      nome: anexo?.categoria,
                    },
                    idFiliacao: anexo?.idFiliacao ? anexo?.idFiliacao : null,
                  },
                };

                return (
                  <Box className="break-page">
                    <CardAnexo
                      title={`${anexo?.tipo ? anexo?.tipo : ""}`}
                      responsavel={`${
                        anexo?.responsavel ? anexo?.responsavel : ""
                      }`}
                      dataDocumento={`${customDateDocument}`}
                      observacoes={`${
                        anexo?.observacao ? anexo?.observacao : ""
                      }`}
                      dataInitial={`${customDateInitial}`}
                      idDelete={anexo?.id}
                      key={anexo?.id}
                      tipoAnexo={data}
                      loginResponsavel={
                        anexo?.loginResponsavel ? anexo?.loginResponsavel : ""
                      }
                    />
                  </Box>
                );
              })}
            </Grid>
          </Group>
        </Flex>
      </Box>
    </>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Anexos"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
